import { Host, h } from '@stencil/core';
export class AibaResultContentBlock {
  constructor() {
    this.data = undefined;
    this.content = undefined;
  }
  render() {
    var _a, _b;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, h("div", { class: "result-content-block-warpper" }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((element) => {
        var _a, _b, _c, _d;
        if (element.name === 'result-content') {
          return (h("div", { class: "result-content" }, (element === null || element === void 0 ? void 0 : element.data) &&
            ((_b = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((item) => {
              var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label' && ((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.tag) === 'h2') {
                return h("aiba-label", Object.assign({}, item['data'], { text: ((_b = this.content) === null || _b === void 0 ? void 0 : _b.heading) ? (_c = this.content) === null || _c === void 0 ? void 0 : _c.heading : item['data']['text'] }));
              }
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label' && item._id === 'attribute' && ((_d = item === null || item === void 0 ? void 0 : item.data) === null || _d === void 0 ? void 0 : _d.tag) === 'p') {
                return h("aiba-label", Object.assign({}, item['data'], { text: ((_e = this.content) === null || _e === void 0 ? void 0 : _e.label) ? this.content.label : item['data']['text'] }));
              }
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label' && item._id === 'score' && ((_f = item === null || item === void 0 ? void 0 : item.data) === null || _f === void 0 ? void 0 : _f.tag) === 'p') {
                return h("aiba-label", Object.assign({}, item['data'], { text: ((_g = this.content) === null || _g === void 0 ? void 0 : _g.score) ? this.content.score : item['data']['text'] }));
              }
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label' && ((_h = item === null || item === void 0 ? void 0 : item.data) === null || _h === void 0 ? void 0 : _h.tag) === 'p' && !((_j = item === null || item === void 0 ? void 0 : item.data) === null || _j === void 0 ? void 0 : _j.setInnerHTML)) {
                return h("aiba-label", Object.assign({}, item['data'], { text: ((_k = this.content) === null || _k === void 0 ? void 0 : _k.description) ? this.content.description : item['data']['text'] }));
              }
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label' && ((_l = item === null || item === void 0 ? void 0 : item.data) === null || _l === void 0 ? void 0 : _l.tag) === 'p' && ((_m = item === null || item === void 0 ? void 0 : item.data) === null || _m === void 0 ? void 0 : _m.setInnerHTML)) {
                return h("aiba-label", Object.assign({}, item['data'], { innerHTML: ((_o = this.content) === null || _o === void 0 ? void 0 : _o.description) ? this.content.description : item['data']['innerHTML'] }));
              }
            }))));
        }
        if (element.name === 'result-content-image') {
          return (h("div", { class: "result-content-image" }, (element === null || element === void 0 ? void 0 : element.data) &&
            ((_d = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((item) => {
              var _a, _b, _c, _d, _e, _f;
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-image') {
                if (!((_a = this.content) === null || _a === void 0 ? void 0 : _a.hideImg)) {
                  return (h("img", { src: ((_b = this.content) === null || _b === void 0 ? void 0 : _b.img) ? (_c = this.content) === null || _c === void 0 ? void 0 : _c.img : item['data']['src'], alt: ((_d = this.content) === null || _d === void 0 ? void 0 : _d.altText) ? (_e = this.content) === null || _e === void 0 ? void 0 : _e.altText : (_f = item === null || item === void 0 ? void 0 : item.data) === null || _f === void 0 ? void 0 : _f.altText }));
                }
              }
            }))));
        }
      })))));
  }
  static get is() { return "aiba-result-content-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-result-content-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-result-content-block.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "content": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "content",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-result-content-block.js.map
